/**
 * it would be good to use performance.now()
 * but it some cases performance API is not available
 */
export function hash() {
  const _performance = globalThis['performance'];

  if (_performance && _performance.now) {
    return _performance.now();
  }

  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  const charactersLength = characters.length;

  let counter = 0;

  const length = 10;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }

  return result;
}
